module.exports = __webpack_public_path__ + "static/media/superior-derecho.75a6b2bc.svg";